import { useState, useEffect } from "react";
import { WIDGETS } from "@/lib/widgets";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function WidgetConfig({ open, onOpenChange, instance, onSave }) {
  const widget = instance ? WIDGETS[instance.type] : null;
  const [cfg, setCfg] = useState({});
  useEffect(() => { if (instance) setCfg({ ...(instance.config || {}) }); }, [instance]);
  if (!widget) return null;

  const set = (k, v) => setCfg((c) => ({ ...c, [k]: v }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="widget-config-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Configure · {widget.title}</DialogTitle>
          <DialogDescription>Choose what this widget shows. Display only — workflow rules are never affected.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          {widget.config.map((opt) => (
            <div key={opt.key}>
              <Label className="text-xs">{opt.label}</Label>
              {opt.type === "select" ? (
                <Select value={String(cfg[opt.key] ?? opt.options[0])} onValueChange={(v) => set(opt.key, v)}>
                  <SelectTrigger className="mt-1" data-testid={`cfg-${opt.key}`}><SelectValue /></SelectTrigger>
                  <SelectContent>
                    {opt.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
                  </SelectContent>
                </Select>
              ) : (
                <Input type="number" min={opt.min} max={opt.max} className="mt-1" data-testid={`cfg-${opt.key}`}
                  value={cfg[opt.key] ?? opt.min ?? 5}
                  onChange={(e) => set(opt.key, Math.max(opt.min || 1, Math.min(opt.max || 50, Number(e.target.value))))} />
              )}
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2 border-t border-border pt-4">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={() => onSave(cfg)} data-testid="save-widget-config">Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
